import CheckboxField from '@planday-corp/ui/forms/fields/CheckboxField';
import Board from '@planday-corp/ui/structure/Board';
import {grey20} from '@planday-corp/ui/styles/colors';
import Text from '@planday-corp/ui/text/Text';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  position: absolute;
  width: 100%;
  /* Respecting the logo margin */
  height: calc(100vh - 12.5rem);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`;

export const BoardGroup = styled(Board)`
  width: 46rem;
  margin: auto;
`;

export const StyledBoardHeading = styled.div`
  margin-bottom: 0.8rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: auto;

  &:after {
    content: '';
    width: calc(100% + 2rem);
    height: 1px;
    position: absolute;
    bottom: 0;
    left: -1rem;
    background: ${grey20};
  }
`;

export const LegendText = styled(Text)`
  margin-bottom: 1rem;
`;

export const InfoText = styled(Text)`
  margin-bottom: 1.5rem;
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 0.5rem;
`;

export const StyledLoadingContainer = styled.div`
  margin: 1rem 0;
  margin-bottom: 1.5rem;
`;

export const StyledTermsAndConditionsTextWrapper = styled.div`
  margin-top: -0.5rem;
`;

export const StyledCheckboxField = styled(CheckboxField)`
  margin-top: 1.25rem;
`;
